import { HttpClient } from '@/components/shared/http-client'

const fetchFieldDefinitions = async () => {
  const url = '/api/schedules/field-definitions'
  const response = await HttpClient.get(url)
  return response
}

const fetchBrokeragePreferences = async brokerCode => {
  const url = `/api/broker-admin/${brokerCode}/preferences`
  const response = await HttpClient.get(url)
  return response
}

const saveBrokeragePreference = async (brokerCode, preferenceName, preferenceValue) => {
  const url = `/api/broker-admin/${brokerCode}/preferences`
  const req = {
    name: preferenceName,
    value: preferenceValue,
  }
  const response = await HttpClient.post(url, req)
  return response
}

// preferenceObj: { account: {value},  brokerage: {value}}
const getPreferenceValueFromObj = preferenceObj => {
  let value = null
  if (preferenceObj) {
    if (preferenceObj.account && preferenceObj.account.value != null) {
      value = preferenceObj.account.value
    } else if (preferenceObj.brokerage && preferenceObj.brokerage.value != null) {
      value = preferenceObj.brokerage.value
    }
  }
  return value
}

// Returns the JSON representation of the array. Array of strings: '["property","auto","driver","equipment","work-comp"]'
const getPreferenceValueFromObjElseDefault = (preferenceObj, defaultValue) => {
  if (preferenceObj) {
    if (preferenceObj.account && preferenceObj.account.value != null) {
      return preferenceObj.account.value
    } else if (preferenceObj.brokerage && preferenceObj.brokerage.value != null) {
      return preferenceObj.brokerage.value
    }
  }
  return defaultValue
}

export { fetchBrokeragePreferences, saveBrokeragePreference, getPreferenceValueFromObj, getPreferenceValueFromObjElseDefault, fetchFieldDefinitions }
